<template>
    <TableLayout :permissions="['renthouse:rhcustomerservice:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="所属城市" prop="cityId">
                <el-select v-model="searchForm.cityId" placeholder="请选择所属城市">
                    <el-option
                        v-for="item in city"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['renthouse:rhcustomerservice:create', 'renthouse:rhcustomerservice:delete']">
                <li><el-button type="primary" @click="$refs.operaRhCustomerServiceWindow.open('新建专属客服信息表')" icon="el-icon-plus" v-permissions="['renthouse:rhcustomerservice:create']">新建</el-button></li>
                <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['renthouse:rhcustomerservice:delete']">删除</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="cityName" label="所属城市" min-width="100px"></el-table-column>
                <el-table-column prop="enterpriseId" label="企业微信客服ID" min-width="100px"></el-table-column>
                <el-table-column label="头像" min-width="100px">
                    <template slot-scope="{row}">
                        <el-image
                            v-if="row.avatar"
                            style="width: 100px; height: 100px"
                            :src="baseUrl + row.avatar"
                            :preview-src-list="[baseUrl + row.avatar]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" min-width="100px"></el-table-column>
                <el-table-column prop="mobile" label="手机号" min-width="100px"></el-table-column>
                <el-table-column prop="described" label="说明" min-width="100px"></el-table-column>
                <el-table-column prop="remark" label="描述" min-width="100px"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
                <el-table-column
                    v-if="containPermissions(['renthouse:rhcustomerservice:update', 'renthouse:rhcustomerservice:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.operaRhCustomerServiceWindow.open('编辑专属客服信息表', row)" icon="el-icon-edit" v-permissions="['renthouse:rhcustomerservice:update']">编辑</el-button>
                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['renthouse:rhcustomerservice:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaRhCustomerServiceWindow ref="operaRhCustomerServiceWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaRhCustomerServiceWindow from '@/components/rentHouse/OperaRhCustomerServiceWindow'

import { fetchList } from '@/api/rentHouse/rhCityInfo'
export default {
  name: 'RhCustomerService',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaRhCustomerServiceWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        cityId: ''
      },
      city: [],
      baseUrl: process.env.VUE_APP_API_IMG
    }
  },
  created () {
    this.config({
      module: '专属客服信息表',
      api: '/rentHouse/rhCustomerService',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
    this.getCity()
  },
  methods: {
    getCity () {
      fetchList({
        page: 1,
        capacity: 99,
        model: {
          display: 1
        }
      }).then(res => {
        this.city = res.records.map(item => {
          return {
            id: item.id,
            name: item.cityName
          }
        })
      })
    }
  }
}
</script>
